// extracted by mini-css-extract-plugin
module.exports = {"reminderTextWrapper":"reminderBox_reminderTextWrapper__1p8bm","remiderTextIcon":"reminderBox_remiderTextIcon__30eT5","remiderText":"reminderBox_remiderText__1644i"};